var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProtecao(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.75C6 15.3358 5.66421 15 5.25 15C4.83579 15 4.5 15.3358 4.5 15.75H5.25H6ZM10 15.75V15H8.5V15.75H9.25H10ZM7.25 17.75V17C6.55964 17 6 16.4404 6 15.75H5.25H4.5C4.5 17.2688 5.73122 18.5 7.25 18.5V17.75ZM9.25 15.75H8.5C8.5 16.4404 7.94036 17 7.25 17V17.75V18.5C8.76878 18.5 10 17.2688 10 15.75H9.25Z",
    fill: "#FF5800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.75C13.2292 0.75 16.7656 4.14453 17.2041 8.5752C17.2081 8.616 17.1963 8.65132 17.1641 8.68457C17.1288 8.72087 17.0716 8.75 17 8.75H1C0.928409 8.75 0.871243 8.72087 0.835938 8.68457C0.803691 8.65132 0.79186 8.616 0.795898 8.5752C1.23443 4.14453 4.77078 0.75 9 0.75Z",
    stroke: "#FF5800",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 14L9.25 9",
    stroke: "#FF5800",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 14V15.5",
    stroke: "#FF5800",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtecao);
export default __webpack_public_path__ + "static/media/protecao.f4a7428a0b7a667d1281e75b696119b4.svg";
export { ForwardRef as ReactComponent };